<template>
  <DashboardHeader title="Admin">
    <DashboardTiles2024 :tiles="tiles"></DashboardTiles2024>
  </DashboardHeader>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DashboardTiles2024 from "@/components/myLibrary/DashboardTiles2024.vue";
// import DashboardTiles from "@/components/myLibrary/DashboardTiles.vue";

export default {
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  components: {
    DashboardHeader,
    DashboardTiles2024,
  },
  mounted() {
    this.$store.commit("setLoader", true);
    axios
      .getData("/auth/write-initial-data-to-database", this.getAccessToken)
      .then(() => {
        this.$store.commit("setLoader", false);
      });
  },
  data() {
    return {
      tiles: [
        {
          icon: "mdi-account-reactivate",
          title: "Admissions",
          description: "",
          color: "purple darken-4",
          route: "admissions",
          buttonText: "Enter",
          alevel: 7,
          param: "",
          industry: "General",
        },
        {
          icon: "mdi-account-details",
          title: "Student Profile",
          description: "",
          color: "teal",
          route: "student-profile",
          buttonText: "Enter",
          alevel: 5,
          param: "",
          industry: "General",
        },
        {
          id: 6,
          icon: "mdi-account-group",
          title: "Manage Students",
          description: "",
          route: "manage-students",
          param: "",
          alevel: 7,
          buttonText: "Enter",
          industry: "General",
        },
        {
          id: 3,
          icon: "mdi-comment",
          title: "Bulk SMS",
          description: "",

          route: "bulk-sms-dashboard",
          param: "",
          alevel: 5,
          buttonText: "Enter",
          industry: "General",
        },
        {
          icon: "mdi-database",
          title: "Edit Any Data",
          description: "",
          color: "yellow darken-4",
          route: "manage-datatables",
          buttonText: "Enter",
          alevel: 7,
          param: "",
          industry: "General",
        },
        {
          id: 6,
          icon: "mdi-cash-multiple",
          title: "Capture Bulk Payments",
          description: "",
          route: "bulk-payments-capturing",
          param: "",
          alevel: 7,
          buttonText: "Enter",
          industry: "General",
        },
        {
          id: 6,
          icon: "mdi-cash-multiple",
          title: "Capture Bulk Expenses",
          description: "",
          route: "bulk-expenses-capturing",
          param: "",
          alevel: 7,
          buttonText: "Enter",
          industry: "General",
        },

        {
          id: 9,
          icon: "mdi-office",
          title: "Excel Uploads",
          description: "",
          route: "sasams-uploads",
          param: "",
          alevel: 7,
          buttonText: "Enter",
          industry: "General",
        },

        {
          icon: "mdi-printer",
          title: "Reports",
          description: "",
          color: "yellow darken-4",
          route: "crud-reports",
          buttonText: "Enter",
          alevel: 7,
          param: "",
          industry: "General",
        },

        {
          icon: "mdi-folder-multiple-image",
          title: "Gallery",
          description: "",
          color: "green darken-4",
          route: "manage-images",
          buttonText: "Enter",
          alevel: 7,
          param: "",
          industry: "General",
        },
      ],
    };
  },
};
</script>

<style></style>
